import { useContext, useEffect, useState } from "react";
import { UserContext } from "controller/context/userContext";
import { AlertContext } from "controller/context/alertContext";
import {
  addModifier,
  updateModifier,
  deleteModifier,
} from "controller/services/modifierServices";

interface Item {
  _id?: string;
  name: string;
  price: string;
  description: string;
}

interface InitialValues {
  items: Item[];
}

export const useModifiers = (modifiersData: any) => {
  const { setAlert } = useContext(AlertContext);
  const { userType } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState<InitialValues>({
    items: [],
  });

  useEffect(() => {
    if (modifiersData && modifiersData.length > 0) {
      setInitialValues({
        items: modifiersData.map((modifier: any) => ({
          _id: modifier._id || undefined,
          name: modifier.name,
          price: modifier.price,
          description: modifier.description,
        })),
      });
    }
  }, [modifiersData]);

  const onSubmit = async (values: any) => {
    setLoading(true);
    try {
      if (values._id) {
        await updateModifier({ id: values._id, data: values, userType });
        setAlert({
          active: true,
          type: "success",
          message: "Modifier updated successfully",
        });
      } else {
        await addModifier({ data: values, userType });
        setAlert({
          active: true,
          type: "success",
          message: "Modifier added successfully",
        });
      }
    } catch (error) {
      setAlert({
        active: true,
        type: "error",
        message: "Error occurred while saving modifier",
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteModifierFromDB = async (id: string) => {
    try {
      await deleteModifier({ id, userType });
      setAlert({
        active: true,
        type: "success",
        message: "Modifier deleted successfully",
      });
    } catch (error) {
      setAlert({
        active: true,
        type: "error",
        message: "Error occurred while deleting modifier",
      });
    }
  };

  return {
    onSubmit,
    initialValues,
    deleteModifierFromDB,
    loading,
  };
};
